import React from 'react'
import moment from 'moment'

const DateTimeGenericComponent = ({ data, attribute, format = 'L LT' }) => {
    const item = data?.item ? data.item : data
    const date = item && item[attribute.name] ? item[attribute.name] : null
    return <>{!date ? '-' : moment.utc(date).clone().local().format(format)}</>
}
export default DateTimeGenericComponent
